const FEATURE_CLICKED = 'feature_clicked' as const;
const TAB = 'billing_and_reports' as const;

export const BILLING_AND_REPORTS_EVENTS = {
  // Tabs
  REPORTS_TAB_SELECTED: {
    action: 'reports_tab_selected',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'tabs',
  },
  BILLING_TAB_SELECTED: {
    action: 'billing_tab_selected',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'tabs',
  },

  // Reports
  REPORT_DOWNLOADED: {
    action: 'report_downloaded',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'reports',
  },
  REPORTS_PERIOD_FILTERED: {
    action: 'period_filtered',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'reports',
  },
  REPORTS_TYPE_FILTERED: {
    action: 'type_filtered',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'reports',
  },

  // Billing
  INVOICE_DOWNLOADED: {
    action: 'invoice_downloaded',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'billing',
  },
  INVOICES_PERIOD_FILTERED: {
    action: 'period_filtered',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'billing',
  },
  INVOICES_TYPE_FILTERED: {
    action: 'type_filtered',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'billing',
  },

  // Subscription
  MANAGE_PAYMENT_CLICKED: {
    action: 'manage_payment_clicked',
    type: FEATURE_CLICKED,
    tab: TAB,
    section: 'subscription',
  },
} as const;
